import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { PQRNovasSalasPrediosDto } from '../../dtos/pqr-novas-salas-predios.dto';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../'

interface ListPQRNovasSalasPredios {
  _embedded: {
    'pqr-novas-salas-predio': PQRNovasSalasPrediosDto[];
  };
}

@Injectable({
  providedIn: 'root',
})
export class PQRNovasSalasPrediosService {
  private apiUrl = `${environment.apiUrl}/pqr-novas-salas-predio`;

  constructor(
    private caqRequestService: CaqRequestService
  ) {}

  buscarListaDePQRNovasSalasPredios(): Observable<PQRNovasSalasPrediosDto[]> {
    return this.caqRequestService
      .get<ListPQRNovasSalasPredios>(this.apiUrl)
      .pipe(map((response) => response._embedded['pqr-novas-salas-predio']));
  }
}
